<template>
    <div class="person">
        <div class="condition">
           
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="search" :reset="reset"></queryCondition>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新建机构</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="机构名称"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="province"
                label="所属省份"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="所属市级"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="district"
                label="所属片区"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteMechanismTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="800px">
            <forms ref="formListAdd" :list="formList" :value="formData" :rules="formRules" :btns="formAddBtns" labelWidth="120px"></forms>
        </el-dialog>

        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑机构" width="800px">
            <forms ref="formListEdit" :list="formList" :value="formData" :rules="formRules" :btns="formEditBtns" labelWidth="120px"></forms>
        </el-dialog>

       
    </div>
</template>
<script>
import api from '../../../api/base'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            selectedOptions:[],
            parentDialog:false,
            district:[],
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,

            queryList:[
                {
                    type: "input",
                    label: "机构名称:",
                    name: "name",
                },
            ],
            conditionData: {
                name: "",
                page:1,
                pageSize:10
            }, 

            parentName:'',
            addData:{},
            updateData:{},
            tableData:[],
            options:regionData,
            level:1,
            isShList:[{
                label:'否',
                value:false,
            },{
                label:'是',
                value:true,
            }],



            formData: {
                name: "",
                address: [],
                remark: "",
            },
            formList:[
                {
                    type: "input",
                    label: "名字:",
                    name: "name",
                },
                {
                    type: "address",
                    label: "地区:",
                    name: "address",
                },
                {
                    type: "textarea",
                    label: "备注:",
                    name: "remark",
                },
            ],
            formRules:{
                name: [
                    { required: true, message: '请填写名字', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请填写地区', trigger: 'change' }
                ],
            },
            formAddBtns:[
                {
                    name:'确认新增',
                    icon:'el-icon-circle-plus',
                    type:'success',
                    handleClick:this.add
                },
                {
                    name:'关闭',
                    icon:'el-icon-error',
                    type:'warning',
                    handleClick:this.close
                }
            ],
            formEditBtns:[
                {
                    name:'确认编辑',
                    icon:'el-icon-edit',
                    type:'success',
                    handleClick:this.edit
                },
                {
                    name:'关闭',
                    icon:'el-icon-error',
                    type:'warning',
                    handleClick:this.close
                }
            ]
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.QueryMechanism(this.conditionData);
            this.tableData = res.data.data;
            // this.totalCount = res.data.data.totalCount;
        },
        search(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                Name:'',
                page:1,
                pageSize:10,
            },
            this.selectedOptions=[];
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.formData = {
                name: "",
                address: [],
                remark: "",
            };
            this.isAddDialog = true;
        },
        async add(){
            let options={
                name:this.formData.name,
                code:'',	
                province:'',	
                city:'',	
                district:'',	
                remark:this.formData.remark,	
            }
            if(this.formData.address[0]){
                options.province = CodeToText[this.formData.address[0]]
                options.code = this.formData.address[0]
            }
            if(this.formData.address[1]){
                options.city = CodeToText[this.formData.address[1]]
                options.code = options.code + ',' + this.formData.address[1]
            }
            if(this.formData.address[2]){
                options.district = CodeToText[this.formData.address[2]]
                options.code = options.code + ',' + this.formData.address[2]
            }
            let res  = await api.CreateMechanism(options);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
                this.formData = {
                    name: "",
                    address: [],
                    remark: "",
                };
            }
        },
        async edit(){
            let options={
                id:this.formData.id,
                name:this.formData.name,
                code:'',	
                province:'',	
                city:'',	
                district:'',	
                remark:this.formData.remark,	
            }
            if(this.formData.address[0]){
                options.province = CodeToText[this.formData.address[0]]
                options.code = this.formData.address[0]
            }
            if(this.formData.address[1]){
                options.city = CodeToText[this.formData.address[1]]
                options.code = options.code + ',' + this.formData.address[1]
            }
            if(this.formData.address[2]){
                options.district = CodeToText[this.formData.address[2]]
                options.code = options.code + ',' + this.formData.address[2]
            }
            let res  = await api.UpdateMechanism(options);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }
            this.updateData = {};
        },
        async isUpdateDialogShow(row){
            this.isUpdateDialog = true;
            this.formData = row;
            this.formData.address = row.code.split(',');
        },
        deleteMechanismTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteMechanism(row){
            console.log(row.id);
            let res  = await api.deleteMechanism({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 100px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
